















































import { Vue, Component, PropSync, Prop, Watch } from "vue-property-decorator";
import EditorWithFile from "@/components/EditorWithFile.vue";
import api from "@/getinfo-api";
import Modal from "@/components/form/Modal.vue";
import {
  IEditPageParams,
  IGetLecturePage,
  IDeleteLecturePage
} from "@/store/modules/lectures/lectures";
import { LecturePage as ILecturePage } from "@/api/models/lecture-page";

@Component({
  components: { EditorWithFile, Modal }
})
export default class LectureEntityFormItem extends Vue {
  @PropSync("item") entity!: any;
  @Prop() sortItem?: number;
  @Prop() entityType?: string;
  @Prop() lectureId?: string;
  modalId: string = this.generateModalId();
  body!: string | undefined;
  showSpinner: boolean = false;

  data() {
    return {
      body: undefined
    };
  }

  get filterPageBodyLength() {
    return this.entity?.body?.length > 60
      ? this.entity.body.substr(0, 50).replace(/(<(\/?[^>]+)>)/g, "") + "..."
      : this.entity.body.replace(/(<(\/?[^>]+)>)/g, "");
  }

  get type() {
    let apiMethod: any;
    if (this.entityType === "pages") {
      apiMethod = api.LecturePageApi;
    }
    return apiMethod;
  }

  generateModalId(): string {
    return Math.random()
      .toString(36)
      .substring(7);
  }

  showModalEditPage() {
    this.$bvModal.show(this.modalId);
    if (!this.entity.id) {
      this.body = this.entity.body;
    } else {
      this.showSpinner = true;

      if (this.lectureId) {
        let params: IGetLecturePage = {
          lectureId: this.lectureId,
          lecturePageId: this.entity.id
        };
        this.$store
          .dispatch("GET_LECTURE_PAGE", params)
          .then((res: { data: ILecturePage }) => {
            this.body = res.data.body;
          })
          .finally(() => {
            this.showSpinner = false;
          });
      }
    }
  }

  deleteItem() {
    if (!this.entity.id) {
      this.$emit("deleteItem", this.entity);
    } else {
      if (this.lectureId) {
        let params: IDeleteLecturePage = {
          lectureId: this.lectureId,
          lecturePage: this.entity.id
        };

        this.$store.dispatch("DELETE_LECTURE_PAGE", params);
      }
    }
  }

  closeModal() {
    this.body = "";
    this.$bvModal.hide(this.modalId);
  }

  save() {
    if (!this.entity.id) {
      this.entity.body = this.body;
      this.$bvModal.hide(this.modalId);
      this.body = "";
    } else {
      this.editExistEntity();
    }
  }

  editExistEntity() {
    if (this.lectureId) {
      let params: IEditPageParams = {
        pageId: this.entity.id,
        lectureId: this.lectureId,
        body: {
          body: this.body,
          sort: this.sortItem
        }
      };
      this.$store.dispatch("EDIT_LECTURE_PAGE", params).then(() => {
        this.body = "";
        this.$bvModal.hide(this.modalId);
      });
    }
  }

  @Watch("entity")
  updateEntityIndex() {
    this.entity.sort = this.sortItem;
  }

  created() {
    this.entity.sort = this.sortItem;
  }
}
